import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from "react-select";

import { getUniqueValues } from '@api/v4/resources/custom_fields';

const CustomFieldsSelector = ({ customFieldKeys, updateCustomFields }) => {
  const [selectedKey, setSelectedKey] = useState(null);
  const [values, setValues] = useState([]); // list of unique values (strings)
  const [selectedValue, setSelectedValue] = useState(null);

  const formatKeyOptions = () => (
    customFieldKeys.map((option) => (
      { label: Object.keys(option)[0], value: Object.values(option)[0] }
    ))
  );

  const formatValueOptions = () => (
    values.map((value) => ({ label: value, value }))
  );

  const updateKey = (selection) => {
    if (selectedKey && selectedKey.value === selection.value) { return undefined; }

    setSelectedKey(selection);
    setSelectedValue(null);
    getUniqueValues(selection.value).then((response) => {
      setValues(response.custom_field_values);
    });

    return undefined;
  };

  const updateValue = (selection) => {
    if (selectedKey && selectedKey.value === selection.value) { return undefined; }

    setSelectedValue(selection);
    updateCustomFields(selectedKey.label, selection.value);
    setSelectedKey(null);
    setSelectedValue(null);
    return undefined;
  };

  return (
    <div className="select-list-dropdown-combo-component flex-row">
      <div className="column">
        <label className="modal-label">{t('Key')}</label>
        <Select
          name="select-custom-key"
          className="filter-dropdown"
          value={selectedKey}
          options={formatKeyOptions()}
          clearable={false}
          searchable
          placeholder="Select Key"
          onChange={updateKey}
        />
      </div>
      {selectedKey && (
        <div className="column">
          <label className="modal-label">{t('Value')}</label>
          <Select
            name="select-custom-value"
            className="filter-dropdown"
            options={formatValueOptions()}
            value={selectedValue}
            clearable={false}
            searchable
            placeholder={selectedKey ? "Select Value" : ""}
            onChange={updateValue}
          />
        </div>
      )}
    </div>
  );
};

CustomFieldsSelector.propTypes = {
  customFieldKeys: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  updateCustomFields: PropTypes.func.isRequired,
};

export default CustomFieldsSelector;
